import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Завантаження...</div>;

  if (!user) {
    console.warn("Користувач не залогінений, перенаправляємо на /login");
    return <Navigate to="/login" replace />;
  }

  console.log("Роль користувача в ProtectedRoute:", user.role);
  console.log("Дозволені ролі:", allowedRoles);

  if (!allowedRoles.includes(user.role)) {
    console.warn("Недостатньо прав, перенаправляємо на /unauthorized");
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
